import { Menu } from "lucide-react";
import { useSnak } from "../snak/SnakContext";
export function TopBar() {
  const {
    openRefs,
    openChapters
  } = useSnak();
  return <header className="mx-auto flex w-full max-w-xl shrink-0 items-center justify-between gap-3 px-6 pb-2 pt-4" data-id="element-117" data-mp="2ux10dzm1n71c">
      <span className="text-[12px] font-semibold tracking-[0.22em]" data-id="element-118" data-mp="38smng18pvgr4">
        BRAND NAME
      </span>
      <div className="flex items-center gap-1" data-id="element-119" data-mp="34vqmy5ovxfnx">
        <button onClick={() => openRefs("compliance")} className="whitespace-nowrap rounded-full bg-amber-soft px-2.5 py-1 text-[10.5px] font-semibold tracking-[0.06em] text-amber" data-id="element-120" data-mp="3is3scgg59qm1">
          NON-BRANDED VERSION
        </button>
        <button onClick={openChapters} aria-label="Open chapter menu" className="-mr-2 flex h-9 w-9 items-center justify-center rounded-full text-[var(--s-fg)] opacity-80 transition-opacity duration-150 hover:opacity-100" data-id="element-121" data-mp="3njvkuwiv26et">
          <Menu className="h-[18px] w-[18px]" strokeWidth={1.75} data-id="element-122" data-mp="gqv4mftln0t" />
        </button>
      </div>
    </header>;
}